export default {
  createOrderMutation(state, data) {
    state.order = data
  },
}
